var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { RecekTextField } from "./RecekTextField";
var TRAILING_DOT = /^\d+\.$/;
var INTEGER = /^-?\d+$/;
var normalize = function (text) {
    var trimmed = text.trim();
    return TRAILING_DOT.test(trimmed) ? trimmed.slice(0, -1) : trimmed;
};
var parse = function (text) {
    if (text === "")
        return undefined;
    return INTEGER.test(text) ? Number(text) : Number.NaN;
};
var toRaw = function (value) {
    return value === undefined || Number.isNaN(value) ? "" : String(value);
};
var sameValue = function (a, b) {
    return a === b || (Number.isNaN(a) && Number.isNaN(b));
};
export var RecekNumberField = forwardRef(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["value", "onChange"]);
    var _b = useState(function () { return toRaw(value); }), raw = _b[0], setRaw = _b[1];
    var valueRef = useRef(value);
    valueRef.current = value;
    var onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    useEffect(function () { return function () {
        var _a;
        if (Number.isNaN(valueRef.current)) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, undefined);
        }
    }; }, []);
    useEffect(function () {
        var normalized = normalize(raw);
        if (normalized !== raw) {
            setRaw(normalized);
        }
    }, [raw]);
    useEffect(function () {
        if (!sameValue(parse(normalize(raw)), value)) {
            setRaw(toRaw(value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    var handleChange = function (e) {
        var text = e.target.value;
        setRaw(text);
        onChange === null || onChange === void 0 ? void 0 : onChange(parse(normalize(text)));
    };
    return (React.createElement(RecekTextField, __assign({}, rest, { ref: ref, type: "text", inputMode: "numeric", value: raw, onChange: handleChange })));
});
